import { configure, hits, index, stats } from 'instantsearch.js/es/widgets';
// import { analyticsWidget } from '../analytics';

/**
 * The search widgets for taxonomy searches
 * Typically used for product categories
 */
const taxonomySearch = {
	searcher: ( search, taxonomy ) => {
		search.addWidgets( [
			index( { indexName: taxonomy.ais_index } ).addWidgets( [
				configure( {
					hitsPerPage: taxonomy.per_page,
					filters: '',
				} ),

				hits( {
					container: `.ma-${ taxonomy.type }-search-result`,
					templates: {
						item: taxonomy.item_template,
						empty: '',
					},
				} ),

				stats( {
					container: `.ma-${ taxonomy.type }-search-header`,
					templates: {
						text: `<header><h2>${ taxonomy.search_result_title }</h2></header>`,
					},
				} ),
			] ),
		] );

		// analyticsWidget( search );
	},
};

export default taxonomySearch;
